import type { EdgeId } from '@ipfabric/utils';
import { unhighlightEdge } from 'components/Graph/commands/edges/unhighlightEdge';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export interface PathLookupDetailLeaveCommand {
  detailId: EdgeId;
}

export const pathLookupDetailLeave: GraphCommandFactory<
  PathLookupDetailLeaveCommand
> = (_cmdContext, dispatch) => (command) => {
  dispatch(unhighlightEdge, {
    color: true,
    thickness: true,
    edgeId: command.detailId,
  });
};
